import styled, { DefaultTheme } from 'styled-components';
import { TertiaryActionButton, Modal, TertiaryActionButtonProps, SafeHtml } from 'ia-react-core';
import { FC } from 'react';
import needHelpIcon from '../../assets/needHelp.svg';

export const StyledNeedHelpButton = styled<FC<TertiaryActionButtonProps>>(TertiaryActionButton)`
  @media only screen and (max-width: 600px)
  {
    background-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainColor?: string } })?.awAuthentication?.mainColor || theme.colors.light};
    mask-image: url(${needHelpIcon});
    mask-size: cover;
    height: 24px;
    width: 24px;
    content: '';
    padding: 0;
    line-height: 24px;
    border: none !important;
    &:hover, &:focus, &:active {
      padding: 0 !important;
    }
  }

  @media only screen and (max-width: 999px)
  {
    margin-right: 16px;
    border: 1px solid ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { needHelpBorderColor?: string } })?.awAuthentication?.needHelpBorderColor || theme.colors.blue5};   
  }

  :not([disabled]), :not(:disabled) {
    &:hover, &:hover:after  {
      color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainHoverColor?: string } })?.awAuthentication?.mainHoverColor || ''};
      border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { needHelpBorderColor?: string } })?.awAuthentication?.needHelpBorderColor || ''};
    }

    &:active, &:active:after  {
      color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainColor?: string } })?.awAuthentication?.mainColor || ''};
      border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainColor?: string } })?.awAuthentication?.mainColor || ''};
    }
  }

  color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainColor?: string } })?.awAuthentication?.mainColor || ''};
  border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { needHelpBorderColor?: string } })?.awAuthentication?.needHelpBorderColor || ''};

  ::after{
    border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { needHelpBorderColor?: string } })?.awAuthentication?.needHelpBorderColor || ''};
  }

  :hover:after{
    border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { needHelpBorderColor?: string } })?.awAuthentication?.needHelpBorderColor || ''};
  }
`;

export const StyledNeedHelpModal = styled(Modal)`
    font-family: ${({ theme }) => theme.fontFamily.regular};
    max-width: 752px;
    width: 92%;
    margin: auto;
    outline: 0px;

    section {
      border-radius: 4px;
    }
    
    .title {
      font-family: ${({ theme }) => theme.fontFamily.special};
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 24px;
    } 
    
    .ianormalsize {
      font-size: 17px !important;
    }

    .rectangle {
      width: 100%;
      height: 1px;
      background-color: ${({ theme }) => theme.colors.gray3};
    }

    img {
      width: 18px;
      height: 18px;
      vertical-align: middle;
    }
    
    span.soustitre {
      font-size: 17px;
      font-weight: bold;
    }

    @media only screen and (max-width: 600px)
    {
      margin-left: 16px;
      margin-right: 16px;
    }
`;

export const StyledPhoneNumber = styled(SafeHtml)`
    display: inline-block;
    margin-top: 20px;
     p > img {
      width: 36px;
      height: 36px;
    }

     p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
    }
    
     p > a {
      text-decoration: none;
      color: ${({ theme }) => theme.colors.blue5};
      font-weight: 600;
      line-height: 1.29;
      background: transparent;
      border: 0;
      padding: 0;
      outline: 0;
    } 

    span.soustitre14 {
      font-size: 14px;
      font-weight: bold;
    }

    p.paragraphspacing4 {
      margin: 0 0 4px 0;
    }

    @media only screen and (max-width: 600px)
    {
        font-size: 14px;
    }
`;

export const StyledBusinessHours = styled(SafeHtml)`   
     p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
    }
    
     p > a {
      font-weight: 600;
      text-decoration: none;
      color: ${({ theme }) => theme.colors.blue5};
    }

    span.soustitre14 {
      font-size: 14px;
      font-weight: bold;
    }

    p.paragraphspacing4 {
      margin: 0 0 4px 0;
    }
`;
